import store from "@plugins/store.ts";
import {
  INTEGRATOR_APP_FEATURE_CATEGORY,
  INTEGRATOR_APP_PROVIDER,
} from "@modules/app/service/app.constant";
import { isEmpty } from "@utils/var.check";

export class AcpHtml5Service {
  static isAppAvailable(provider: string, category: string): boolean {
    const apps = store.getters["app/getIntegratorAppAccessByCategory"](category);
    const appFound = apps.find((app) => app.provider === provider);

    if (isEmpty(appFound)) return false;
    return appFound.enabled && appFound.accessible;
  }

  static isAcpHtml5AppAvailable(): boolean {
    return this.isAppAvailable(
      INTEGRATOR_APP_PROVIDER.ANTHROPIC,
      INTEGRATOR_APP_FEATURE_CATEGORY.ACP_HTML5,
    );
  }
}
